import React from "react";

const AdminFooter = () => {
  return (
    <>
      <footer className="app-footer">
        <div className="float-end d-none d-sm-inline">
          <strong>Powered by &copy; Open Learning Development Center(OLDC)</strong>
        </div>
        <strong>
         School of Open Learning (SOL)
        </strong>
      </footer>
    </>
  );
};

export default AdminFooter;
